(function () {

  // === 1. Variant Sync ===
  function syncMagicBundleSize(variantId) {
    var variantSelect = document.querySelector('select[name="id"]');
    if (!variantSelect) return;

    var selectedOption = variantSelect.querySelector('option[value="' + variantId + '"]');
    if (!selectedOption) return;

    var selectedText = selectedOption.textContent.trim();

    var mbSizeSelects = document.querySelectorAll('magic-bundle select[data-option-name="Size"]');
    mbSizeSelects.forEach(function (mbSelect) {
      var matchingOption = Array.from(mbSelect.options).find(function (opt) {
        return selectedText.toLowerCase().indexOf(opt.value.toLowerCase()) !== -1 ||
               opt.value.toLowerCase().indexOf(selectedText.toLowerCase()) !== -1;
      });
      if (matchingOption) {
        mbSelect.value = matchingOption.value;
        mbSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  var lastVariantId = null;
  setInterval(function () {
    var variantSelect = document.querySelector('select[name="id"]');
    if (!variantSelect) return;
    var currentId = variantSelect.value;
    if (currentId !== lastVariantId) {
      lastVariantId = currentId;
      syncMagicBundleSize(currentId);
    }
  }, 300);

  // === 2. RFQ Block ===
  function injectRFQ() {
    if (document.querySelector('.rfq-block')) return;
    var form = document.querySelector('form[id^="product_form_"]');
    if (!form) return;

    var rfq = document.createElement('div');
    rfq.className = 'rfq-block';
    rfq.innerHTML =
      '<div class="rfq-block__title">Buy 50 or More</div>' +
      '<div class="rfq-block__subtitle">Request a quote for bulk pricing</div>' +
      '<a href="/pages/contact" class="rfq-block__button">Request a Quote</a>';
    form.insertAdjacentElement('afterend', rfq);
  }

  var observer = new MutationObserver(function () {
    if (document.querySelector('form[id^="product_form_"]')) {
      injectRFQ();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  injectRFQ();

})();

